import { useState, useEffect } from 'react';

export const ThemeToggle = () => {

    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    const defualtTheme = ('theme' in localStorage) ? localStorage.theme : systemTheme;
    const [theme, setTheme] = useState(defualtTheme);

    useEffect(() => {
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
            localStorage.theme = 'dark';
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.theme = 'light';
        }
    }, [theme]);

    return (
        <div className="relative inline-flex items-center gap-2 rounded-full bg-white p-1 transition-colors duration-500 dark:bg-zinc-700">

            <span
                aria-hidden="true"
                className={`
                    absolute left-1 top-1 z-0 size-7 lg:size-6 rounded-full shadow-sm transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)]
                    ${theme === 'light'
                        ? 'translate-x-0 bg-gray-50 ring-1 ring-inset ring-gray-200'
                        : 'translate-x-[calc(100%+0.5rem)] bg-zinc-600 ring-1 ring-inset ring-white/10'
                    }
                `}
            />

            <button
                onClick={() => setTheme('light')}
                className={`
                    relative z-10 flex size-7 lg:size-6 items-center justify-center rounded-full transition-colors duration-200 focus-within:outline-none
                    ${theme === 'light' ? 'text-gray-900' : 'text-gray-400 dark:text-gray-500'}
                `}
                aria-label='Switch to light theme'
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
                </svg>
            </button>

            <button
                onClick={() => setTheme('dark')}
                className={`
                    relative z-10 flex size-7 lg:size-6 items-center justify-center rounded-full transition-colors duration-200 focus-within:outline-none
                    ${theme === 'dark' ? 'text-white' : 'text-gray-400'}
                `}
                aria-label='Switch to dark theme'
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
                </svg>
            </button>
        </div>
    );
};
